module.exports = __webpack_public_path__ + "img/ring_y_0_null_null@2x.f9db4e66.png";